import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field, SubmissionError } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { pascalCase } from 'change-case'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { validations, validateCase as vCase } from 'core/validate'
import { CreateBankGuaranteeContainer } from './styled'
import { bgVendorRequestCreatePath } from 'routes'
import { getVendors, getCompanies } from 'ducks/options'

const CreateBankGuaranteeModal = (props) => {
  const { valueForm, handleSubmit, closeForm, history, vendorOptions, companyOptions } = props

  useEffect(() => {
    if (!vendorOptions.data.length && !vendorOptions.loading) {
      props.getVendors()
    }

    if (!companyOptions.data.length && !companyOptions.loading) {
      props.getCompanies()
    }
  }, [])

  const submitCreateForm = () => {
    var errors = {}

    validations(valueForm, 'vendorCode', [vCase.require], errors)
    validations(valueForm, 'companyCode', [vCase.require], errors)

    if (Object.keys(errors).length) {
      throw new SubmissionError(errors)
    } else {
      closeForm()
      history.push(bgVendorRequestCreatePath(valueForm.createType))
    }
  }

  return (
    <Dialog className='dialog-full-height' open={true} maxWidth='sm' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Request {pascalCase(valueForm.createType)} Bank Guarantee</DialogTitle>
      <DialogContent>
        <form>
          <CreateBankGuaranteeContainer>
            <div className='rowFields'>
              <Field 
                name='createType' 
                label='' 
                type={type.radio}
                options={[
                  { value: 'return', text: 'Return' },
                  { value: 'change', text: 'Change' }
                ]} 
                fieldInputStyle={{ justifyContent: 'space-around' }}
                horizontalView
                component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field 
                name='companyCode' 
                label='Company' 
                require
                ignoreClearValue={false}
                type={type.select}
                options={companyOptions.data}
                loading={companyOptions.loading}
                component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field 
                name='vendorCode' 
                label='Vendor' 
                require
                ignoreClearValue={false}
                type={type.select}
                options={vendorOptions.data}
                loading={vendorOptions.loading}
                component={FieldInput} />
            </div>
          </CreateBankGuaranteeContainer>
        </form>
      </DialogContent>
      <DialogActions>
        <form onSubmit={handleSubmit(values => submitCreateForm())}>
          <Button
            color='red'
            content='Cancel'
            type='button'
            onClick={() => closeForm()}
          />
          <Button
            color='blue'
            content='Create'
            type='submit'
          />
        </form>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const vf = getFormValues('formBGRequest')(state) || {}
  return ({
    valueForm: vf,
    initialValues: {
      ...vf,
      createType: vf.createType || 'return',
    },
    vendorOptions: state.options.vendors,
    companyOptions: state.options.companies,
    bgRefOptions: state.bg.bgRefOptions
  })
}
  
const mapDispatchToProps = {
  getVendors, 
  getCompanies
}

const CreateBankGuaranteeModalForm = reduxForm({
  form: 'formBGRequest',
  enableReinitialize: true,
  destroyOnUnmount : false
})(CreateBankGuaranteeModal)

export default connect(mapStateToProps, mapDispatchToProps)(CreateBankGuaranteeModalForm)
